/* Modulo: Product Catalog — sort control only.
 *
 * The whole grid is server-rendered; the only thing JS does is let the sort
 * <select> submit itself. The submit button ships VISIBLE and is hidden here,
 * because with JS off a select cannot submit and a hidden button would leave a
 * dead control (the `slg` reveal rule, inverted).
 */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function initSort(form) {
    if (form.hasAttribute('data-pct-sort-ready')) return;
    form.setAttribute('data-pct-sort-ready', '');

    var select = form.querySelector('[data-pct-sort-select]');
    var go = form.querySelector('[data-pct-sort-go]');
    if (!select) return;

    if (go) {
      /* Restated in CSS terms rather than via [hidden]: an author display rule
       * on a <button> beats the UA's [hidden]{display:none} (the `sr` lesson). */
      go.style.display = 'none';
      go.setAttribute('hidden', '');
    }

    select.addEventListener('change', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  function bootstrap(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll('[data-pct-sort]');
    for (var i = 0; i < forms.length; i++) initSort(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(document); });
  } else {
    bootstrap(document);
  }

  /* An identical <script src> still executes once per tag, so the document-level
   * listener is wired at most once. */
  if (!window.moduloPctWired) {
    window.moduloPctWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      bootstrap(e.target || document);
    });
  }
})();
